import { useState } from 'react';

import { VerticalContainer } from '@/components';
import { cn } from '@/lib/cn';

import { SectionHeading } from '@/caregiverSpace/shared/ui';

import { ExpandToggle } from './ExpandToggle';

type ExpandableSectionProps = {
    text: string;
    expandedText?: string;
    children: React.ReactNode;
    className?: string;
    expandedOnStart?: boolean;
    onCollapse?: () => void;
};
export const ExpandableSection = ({
    text,
    expandedText,
    children,
    className,
    expandedOnStart = false,
    onCollapse,
}: ExpandableSectionProps) => {
    const [isExpanded, setIsExpanded] = useState(expandedOnStart);

    return (
        <VerticalContainer className={cn('px-4 py-2', className)}>
            <SectionHeading
                onClick={() => {
                    if (isExpanded) {
                        onCollapse?.();
                    }
                    setIsExpanded(!isExpanded);
                }}
                className="cursor-pointer"
                text={isExpanded && expandedText ? expandedText : text}
                rightElement={<ExpandToggle isExpanded={isExpanded} />}
            />
            {isExpanded && children}
        </VerticalContainer>
    );
};
